function anim () {
    /**
     * Анимация текста внутри обертки
     */
    const animInnerTxt = document.querySelectorAll('[data-anim-inner-text]');

    if(animInnerTxt.length > 0) {
        animInnerTxt.forEach(el=> {
            const textNodes = el.querySelectorAll('*');
            
            textNodes.forEach(el=> {
                el.dataset.anim = '';
            });
        });
    }

    
    /**
     * Анимация, которая срабатывает только при скролле страницы
     */
    const anim = document.querySelectorAll('[data-anim]');
    
    function animToScroll(el) {
        const observerAnim = new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    let time = entry.target.getAttribute('data-time');

                    if(!time) {
                        entry.target.classList.add('anim');
                    } else {
                        setTimeout(()=> {
                            entry.target.classList.add('anim');
                        }, time);
                    }
                }
            });
        }, {threshold: [.6]});
        observerAnim.observe(el);
    }

    if(anim.length > 0) anim.forEach(el=> {animToScroll(el)});


    /**
     * Анимация, которая запускается сразу при загрузке страницы
     */
    const animMomentumEl = document.querySelectorAll('[data-anim-momentum]');

    if(animMomentumEl.length > 0) {
        animMomentumEl.forEach(el=> {
            let time = el.getAttribute('data-time');

            if(!time) {
                el.classList.add('anim');
            } else {
                setTimeout(()=> {
                    el.classList.add('anim');
                }, time);
            }
        });
    }
}

export default anim;